export let filesStore = []

function preventDefaults(e) {
  e.preventDefault()
  e.stopPropagation()
}

document.addEventListener('DOMContentLoaded', () => {
  const dropArea = document.getElementById('dropArea')
  const fileInput = document.getElementById('fileInput')

  const dropAreaBtn = document.querySelector('[data-drop-area-btn]')
  // dropAreaBtn?.addEventListener('click', (e) => {
  //   e.preventDefault()
  //   fileInput && fileInput.focus()
  // })

  dropAreaBtn?.addEventListener('mouseleave', () => {
    fileInput && fileInput.blur()
  })

  dropAreaBtn?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      fileInput && fileInput.focus()
    }
  })

  dropArea?.addEventListener('mouseout', () => {
    fileInput && fileInput.blur()
  })

  // dropArea?.addEventListener('click', () => {
  //   preventDefaults
  // })

  dropArea?.addEventListener('dragover', preventDefaults)
  dropArea?.addEventListener('dragenter', preventDefaults)
  dropArea?.addEventListener('dragleave', preventDefaults)
  dropArea?.addEventListener('drop', handleDrop)

  function handleDrop(e) {
    e.preventDefault()

    let files = e.dataTransfer.files

    if (files.length) {
      fileInput.files = files

      for (const item of files) {
        filesStore.push(item)
      }

      handleFiles()
    }
    dropArea.classList.remove('drop-area--over')
  }

  dropArea?.addEventListener('dragover', () => {
    dropArea.classList.add('drop-area--over')
  })

  dropArea?.addEventListener('dragleave', () => {
    dropArea.classList.remove('drop-area--over')
  })

  fileInput?.addEventListener('change', () => {
    if (fileInput.files.length) {
      let files = fileInput.files

      for (const item of files) {
        filesStore.push(item)
      }

      handleFiles()
    }
  })

  function handleFiles() {
    const filesContainer = document.querySelector('[data-files-container]')
    filesContainer.innerHTML = ''

    let imgType = ''

    filesStore.forEach((item, index) => {
      const preview = document.createElement('div')
      const fileExtension = document.createElement('img')
      const fileName = document.createElement('div')
      const fileAction = document.createElement('div')
      const fileSize = document.createElement('div')
      const fileLink = document.createElement('button')

      preview.setAttribute('class', 'card-file')

      fileExtension.setAttribute('class', 'card-file__extension')
      fileExtension.setAttribute('decoding', 'async')
      fileExtension.setAttribute('alt', 'icon')
      fileExtension.setAttribute('loading', 'lazy')
      fileExtension.setAttribute('aria-hidden', 'true')

      fileName.setAttribute('class', 'card-file__name')
      fileSize.setAttribute('class', 'whitespace-nowrap text-text-secondary')
      fileAction.setAttribute('class', 'card-file__actions')

      fileLink.setAttribute('class', 'link button-link')
      fileLink.setAttribute('type', 'button')
      fileLink.textContent = foivL10n.delete
      fileName.textContent = item.name
      fileSize.textContent = formatBytes(item.size)

      preview.id = `file${index}`
      preview.appendChild(fileExtension)
      preview.appendChild(fileName)
      preview.appendChild(fileAction)

      switch (item.type) {
        case 'image/gif':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-gif.svg'
          break
        case 'image/tiff':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-tif.svg'
          break
        case 'application/pdf':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-pdf.svg'
          break
        case 'application/vnd.ms-powerpoint':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-ppt.svg'
          break
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-pptx.svg'
          break
        case 'application/rtf':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-rtf.svg'
          break
        case 'image/bmp':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-bmp.svg'
          break
        case 'text/plain':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-txt.svg'
          break
        case 'image/jpeg':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-jpg.svg'
          break
        case 'image/png':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-png.svg'
          break
        case 'application/msword':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-doc.svg'
          break
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-docx.svg'
          break
        case 'application/vnd.ms-excel':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-xls.svg'
          break
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-xlsx.svg'
          break
        default:
          imgType =
            '/app/themes/foiv-osp/frontend/dist/images/icon-file-unknown.svg'
      }

      fileExtension.setAttribute('src', imgType)
      fileLink.setAttribute('id', index)
      fileAction.appendChild(fileSize)
      fileAction.appendChild(fileLink)

      filesContainer.appendChild(preview)

      document.getElementById(index).addEventListener('click', (e) => {
        e.stopImmediatePropagation()
        const el = document.getElementById(preview.id)

        filesStore.splice(index, 1)
        el && el.remove()
        //fileInput && fileInput.focus()
        dropArea?.focus()
      })
    })
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) {
      return '0'
    } else {
      var k = 1024
      var dm = decimals < 0 ? 0 : decimals
      var sizes = [
        'байт',
        'КБ',
        'МБ',
        'ГБ',
        'ТБ',
      ]
      var i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    }
  }
})
